import React from "react";
import Select from "react-select";
import {
	Alert,
	Button,
	ButtonGroup,
	Form,
	Input,
	InputGroup,
	InputGroupText,
	Modal,
	ModalBody, ModalFooter,
	ModalHeader
} from "reactstrap";
import {Glob as G} from "../libs/Glob.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import "./FormChooser.css";
import appLib from "../libs/appLib.mjs";
import ButtonsExitReloadSave from "../controls/ButtonsExitReloadSave.mjs";
import CheckIcon from "../media/images/CheckIcon.mjs";
import TrashIcon from "../media/images/TrashIcon.mjs";
import ReloadIcon from "../media/images/ReloadIcon.mjs";
import EditIcon from "../media/images/EditIcon.mjs";
import FileIcon from "../media/images/FileIcon.mjs";
import ExitIcon from "../media/images/ExitIcon.mjs";
import CdIcon from "../media/images/CdIcon.mjs";

/** @private */
const prefix = 'FormChooser';

const NewItemForm = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			id: "",
			nameError: G.label('Short'),
			idError: '',
			valid: false,
			labStyle: {width:'100px',textAlign:'end'}
		};
		this.setValue = this.setValue.bind(this);
		this.setForSubmit = this.setForSubmit.bind(this);
	}
	setValue( field, value = "" ) {
		return new Promise( resolve => {
			const ns = {};
			if ( field === "id") {
				if ( value.length > 0 ) {
					value = (value||"").trim();
					value = value.replace(/[^a-z0-9_.-]/ig,'').replace(/^[^a-z]*/i,'');
				}
				ns.id = value;
				if ( value ) {
					ns.idError = value.length > 8 ? '' : G.label('Short');
					if ( ! ns.idError ) {
						if ( this.props.known.find(o => o.value === value ) ) ns.idError = G.label('Duplicated');
					}
				} else {
					ns.idError = '';
				}
			} else if ( field === "name" ) {
				value = value.replace(/\s+/g,' ').replace(/^ /,'');
				ns.name = value;
				value = value.trim();
				ns.nameError = value.length > 6 ? '' : G.label('Short');
				if ( ! ns.nameError) {
					if ( this.props.known.find(o => o.label === value ) ) ns.nameError = G.label('Duplicated');
				}
			}
			this.setState( ns, ()=>{
				this.setState({ valid: (this.state.nameError + this.state.idError).length === 0 }, ()=>{
					resolve( this.state.valid );
				});
			});
		});
	}
	async setForSubmit() {
		await this.setValue('name', this.state.name.trim() );
		return this.setValue('id', this.state.id.replace(/[^a-z0-9]*$/,'') );
	}
	render() {
		return(
			<Form
				autoComplete={"off"}
				onSubmit={ async (e) => {
					e.preventDefault();
					if ( ! this.state.valid ) return;
					if (! await this.setForSubmit()) return ;
					this.props.onSubmit({
						name: this.state.name,
						id: this.state.id || G.generateUid()
					});
				}}
			>
				<InputGroup>
					<InputGroupText>
						<span style={this.state.labStyle}>
							<TextLabel value={"Name"} />:
						</span>
					</InputGroupText>
					<Input
						autoFocus={ this.props.known.length === 0 }
						type="text"
						name={"name"}
						valid={ ! this.state.nameError }
						invalid={ !! this.state.nameError }
						value={ this.state.name }
						onChange={ (e) => {
							this.setValue('name', e.target.value );
						}}
					/>
					{ this.state.nameError && (
						<InputGroupText>
							🚫 {this.state.nameError}
						</InputGroupText>
					)}
					<InputGroupText>
						<Button
							disabled={ ! this.state.valid }
							type={"submit"}
							color={"success"}
							className={"btn-icon"}
						>
							<b>
								<TextLabel value={"Add"}/>
							</b>
							<i>
								<CheckIcon/>
							</i>
						</Button>
					</InputGroupText>
				</InputGroup>
				<InputGroup
					className={"mt-2"}
				>
					<InputGroupText>
						<span style={this.state.labStyle}>
							<TextLabel value={"ID"} />:
						</span>
					</InputGroupText>
					<Input
						type={"text"}
						name={"id"}
						invalid={ !! this.state.idError }
						valid={ !! (this.state.id && ! this.state.idError) }
						placeholder={G.label("EmptyAutoVale")}
						value={this.state.id}
						onChange={ (e) => {
							this.setValue('id', e.target.value );
						}}
					/>
					{ this.state.idError && (
						<InputGroupText>
							🚫 {this.state.idError}
						</InputGroupText>
					)}
					<InputGroupText>
						<ButtonGroup
							className={"btn-icon"}
						>
							<Button
								color={"danger"}
								disabled={ this.state.id.length === 0 }
								onClick={ ()=>{ this.setValue( "id", "" ) } }
								title={ G.label('Empty') }
							>
								<i>
									<TrashIcon />
								</i>
							</Button>
							<Button
								color={"primary"}
								onClick={ ()=>{ this.setValue( "id", G.generateUid() ) } }
								title={ G.label('Auto') }
							>
								<i>
									<ReloadIcon />
								</i>
							</Button>
						</ButtonGroup>
					</InputGroupText>
				</InputGroup>
			</Form>
		)
	}
}

const RenamerModal = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			orig: String(props.item?.name),
			value: String(props.item?.name),
			error: G.label('No change')
		};
		this.setValue = this.setValue.bind(this);
		this.ModalAutoFocus = this.ModalAutoFocus.bind(this);
	}
	ModalAutoFocus() {
		const selector = ('modal-dialog '+prefix + '-renameAction').split(' ').join('.');
		const dlog = document.querySelector('.'+selector+' .modal-body');
		if ( ! dlog ) return;
		const input = dlog.querySelector('input[type="text"]:not([disabled]), input[type="password"]:not([disabled])');
		if ( input ) input.focus();
	}
	setValue(nv = "") {
		nv = nv.replace(/\s+/g,' ');
		const ns = { value: String(nv) };
		nv = nv.trim();
		const id = this.props.item?.id;
		let error = ( nv.length > 6 ) ? '' : G.label('Short');
		if ( ! error ) {
			if ( nv !== this.state.orig ) {
				if ( this.props.options.filter( v => v.value !== id ).find( v => v.label === nv ) ) error = G.label('Duplicated');
			} else {
				error = G.label('No change');
			}
		}
		ns.error = error ? error : undefined;
		this.setState( ns );
	}
	render() {
		return(
			<Modal
				className={prefix + '-renameAction'}
				isOpen={ this.props.open }
				toggle={ this.props.closer }
				onOpened={ this.ModalAutoFocus }
			>
				<Form
					autoComplete={"off"}
					onSubmit={e => {
						e.preventDefault();
						if ( this.state.error ) return;
						this.props.saver( this.state.value );
					}}
				>
					<ModalHeader toggle={ this.props.closer }>
						<TextLabel value={"Rename"} />
					</ModalHeader>
					<ModalBody>
						<InputGroup className="mb-3">
							<InputGroupText className={"w-100"}>
								{ this.state.orig }
							</InputGroupText>
						</InputGroup>
						<Input
							type={"text"}
							name={"name"}
							valid={ ! this.state.error }
							invalid={ !! this.state.error }
							value={ this.state.value }
							onChange={ e => this.setValue(e.target.value) }
						/>
						{ this.state.error && (<Alert color="danger">{this.state.error}</Alert>) }
					</ModalBody>
					<ModalFooter>
						<Button
							type="submit"
							color="success"
							className={"btn-icon"}
							disabled={ !! this.state.error }
						>
							<b>
								<TextLabel value={"Save"} />
							</b>
							<i>
								<CdIcon />
							</i>
						</Button>
					</ModalFooter>
				</Form>
			</Modal>
		)
	}
}

class FormChooser extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = {
			groupID: appLib.group(),
			user: G.getStatus('userLogin'),
			admin: !! G.userIsAdmin(),
			itemID: G.getPageParam('item'),
			loading: true,
			loaded: false
		};
		this.autoLoad = this.autoLoad.bind(this);
		this.makeButtons = this.makeButtons.bind(this);
		this.reloadItemsList = this.reloadItemsList.bind(this);
		this.createItem  = this.createItem.bind(this);
		this.chooseItem = this.chooseItem.bind(this);
		this.uid = G.generateUid(prefix);
	}

	componentDidMount() {
		/* startup checks */
		if ( ! this.state.user ) {
			console.log(prefix+': Missing login');
			G.gotoPage('Login');
			return;
		}
		if ( ! this.state.groupID ) {
			console.log(prefix+': Missing group', this.state);
			G.gotoHomePage();
			return;
		}
		if ( ! this.state.admin && ! this.state.user.groups.find( g => g?.id === this.state.groupID ) ) return G.gotoHomePage();
		G.register( 'userLogin', () => { G.gotoHomePage(); }, this.uid);
		/* startup ops */
		G.trigger('pageButtons' );
		this.setState({loading: true, loaded: false }, this.autoLoad );
	}

	componentWillUnmount() {
		G.trigger('pageButtons');
		G.deregister(this.uid);
	}

	reloadItemsList() {
		return new Promise( async ( resolve ) => {
			await this.chooseItem();
			const items = await appLib.getItemsList( this.state.groupID, true);
			const opts = items.map( i => ({ label: i.name, value: i.id }));
			this.setState(
				{items: items, options: opts },
				()=>{ resolve(items); }
			);
		});
	}

	autoLoad() {
		if ( ! this.state.formInfo) {
			appLib.getFormInfo()
				.then( fi  => {
					G.setStatus('pageTitle', fi?.group?.name);
					this.setState({ formInfo: fi }, ()=>{
						setTimeout( this.autoLoad );
					});
				}).catch( e => {
					console.error(prefix+': loading formInfo',e);
					G.gotoHomePage();
				});
			return;
		}
		if ( typeof this.state.items === 'undefined') {
			this.reloadItemsList().then( ()=> {
				setTimeout( this.autoLoad );
			}).catch( e => {
				console.error(prefix+': loading items',e);
				G.gotoHomePage();
			});
			return;
		}
		this.setState({ loading: false, loaded: true }, this.makeButtons );
	}

	makeButtons() {
		if ( this.state.loading ) return G.trigger('pageButtons' );
		if ( this.state.item ) {
			const cc = this.state.formInfo?.group?.canCreateItem || G.userIsAdmin();
			G.trigger('pageButtons',(
				<div className={"d-flex align-items-center"}>
					<ButtonGroup
						className={"btn-icon me-2"}
					>
						<Button
							color={"warning"}
							onClick={ ()=>{ G.gotoHomePage()} }
						>
							<i>
								<ExitIcon />
							</i>
							<b>
								<TextLabel value={"Exit"} />
							</b>
						</Button>
						{ cc && (
							<>
								<Button
									color={"danger"}
									disabled={ ! this.state.item }
									onClick={ ()=>{
										const l = G.label('ConfirmItemDeletion', { item: `“${this.state.item.name}”`})
										if ( ! window.confirm(l)) return;
										if ( ! window.confirm(G.label('Last warning').toUpperCase()+"\n\n"+l)) return;
										appLib.rmItem( this.state.item.id ).then(
											this.reloadItemsList
										).catch( e => {
											console.error(e);
										})
									}}
								>
									<i>
										<TrashIcon />
									</i>
									<b>
										<TextLabel value={"Remove"} />
									</b>
								</Button>
								<Button
									color={"warning"}
									disabled={!this.state.item}
									onClick={  ()=>{ this.setState({renameActionActive:true}) } }
								>
									<b>
										<TextLabel value={"Rename"}/>
									</b>
									<i>
										<FileIcon/>
									</i>
								</Button>
							</>
						) }
					</ButtonGroup>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"primary"}
							disabled={!this.state.item}
							onClick={ ()=>{ G.gotoPage({name:'Form', params: G.getPageParams() }); } }
						>
							<b>
								<TextLabel value={"Edit"}/>
							</b>
							<i>
								<EditIcon/>
							</i>
						</Button>
					</ButtonGroup>
				</div>
			));
			return;
		}
		G.trigger('pageButtons',(
			<ButtonsExitReloadSave
				key={Date.now()}
				exit={ ()=>{ G.gotoHomePage() } }
			/>
		));
	}

	createItem( data ) {
		appLib.setItemData( data ).then( () => {
			this.reloadItemsList();
		}).catch( e => {
			console.error(e);
		})
	}

	chooseItem(option ) {
		return new Promise( resolve => {
			if ( typeof option === 'string' ) option = this.state.options.find( o  => o.value === option );
			let item;
			if ( option && option?.value ) {
				G.setCurrentPageParam('item', option.value);
				item = {id: option.value, name: option.label};
			} else {
				G.rmCurrentPageParam('item');
			}
			this.setState({item: item}, ()=>{
				this.makeButtons();
				resolve()
			});
		})
	};

	render() {
		if ( this.state.loading ) return <div><TextLabel value={"Loading…"}/></div>;
		const qtFields = ( this.state.formInfo?.formDefinition?.fields || []).length;
		const qtItems = (this.state.options||[]).length;
		const cc = this.state.formInfo?.group?.canCreateItem || G.userIsAdmin();
		return(
			<div className={"FormChooser"} id={this.uid}>
				<div className={"formInfo"}>
					<span>
						<TextLabel value={"Form definition"}/>:
					</span>
					{ qtFields === 0 && <span><TextLabel value={"formIsEmpty"}/>,</span> }
					<span>
						<TextLabel
							value={"lastUpdate"}
							params={{ date: this.state.formInfo.lastUpdate ? new Date(this.state.formInfo.lastUpdate).toLocaleDateString(G.getLanguageLong()) : undefined }}
						/>
					</span>
					{ this.state.admin && (()=>{
						const p = { name:'Admin', params: { group: this.state.groupID, tab: 'Groups' } };
						return (
							<span>
								[<a href={G.page2uri(p)} onClick={() => { G.gotoPage(p); }}>
									<TextLabel value={"Admin"}/>
								</a>]
							</span>
						);
					})()}
				</div>
				<div className={"ItemChooser"}>
					<h4>
						<TextLabel value={"Available items"}/>
						{qtItems > 0 ? ` (${qtItems})` : ''}
					</h4>
					<div className={"ItemChooserSelector"}>
						<div
							className={"Select"}
						>
							<Select
								options={ this.state.options }
								value={ this.state.item ? this.state.options.find( o => o.value === this.state.item?.id ) : null }
								isDisabled={ ! qtItems }
								isClearable={true}
								autoFocus={ !! qtItems }
								placeholder={ G.label( qtItems > 0 ? 'Select' : 'NoItemsFound' ) }
								onChange={ this.chooseItem }
								menuPortalTarget={document.body}
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
							/>
						</div>
						<ButtonGroup
							className={"btn-icon"}
						>
							<Button
								color={"primary"}
								disabled={!this.state.item}
								onClick={()=>{ G.gotoPage({name:'Form', params: G.getPageParams() }); }}
							>
								<b>
									<TextLabel value={"Edit"}/>
								</b>
								<i>
									<EditIcon/>
								</i>
							</Button>
						</ButtonGroup>
					</div>
				</div>
				{ cc && (
					<div className={"ItemsCreator"}>
						<h4>
							<TextLabel value={"New item"}/>
						</h4>
						<NewItemForm
							key={qtItems}
							known={this.state.options}
							onSubmit={this.createItem}
						/>
					</div>
				)}
				{ cc && this.state.item && (
					<RenamerModal
						open={ this.state.renameActionActive }
						item={ this.state.item }
						options={ this.state.options }
						closer={ ()=>{ this.setState({renameActionActive: false}) } }
						saver={ async (newName) => {
							const id = this.state.item?.id;
							await this.chooseItem();
							this.setState({renameActionActive: false});
							await appLib.renameItem( newName, id );
							await this.reloadItemsList();
							this.chooseItem( id );
						}}
					/>
				) }
			</div>
		);
	}
}

export default FormChooser;